import { render, staticRenderFns } from "./ServiceTabs.vue?vue&type=template&id=14756ee2&scoped=true&"
import script from "./ServiceTabs.vue?vue&type=script&lang=js&"
export * from "./ServiceTabs.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTabs.vue?vue&type=style&index=0&id=14756ee2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14756ee2",
  null
  
)

export default component.exports